import { UserFlags, EnvFlags } from 'ha/constants/FeatureFlags';

import { getFeatureFlags } from '../reducer';

interface Store {
  // tslint:disable-next-line no-any
  getState: () => any;
}

export default (
  featureFlag: UserFlags | EnvFlags,
  { getState }: Store,
): boolean => {
  const featureFlags = getFeatureFlags(getState());

  return (
    featureFlags[featureFlag] &&
    (featureFlags[featureFlag] === 'on' || featureFlags[featureFlag] === true)
  );
};
